import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CouponReveal } from "@/components/CouponReveal";
import { api } from "@/lib/api";

export default function Kupong() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/coupon/${token}`)
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.data?.detail || "Kupongen ble ikke funnet"));
  }, [token]);

  if (error || (data && data.utlopt)) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#1A1715] px-6 text-center">
        <Logo />
        <p className="text-[#A8A29E]" data-testid="coupon-error">
          {error || "Denne kupongen er dessverre utløpt."}
        </p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#1A1715] text-[#A8A29E]">Laster…</div>
    );
  }

  return (
    <CouponReveal
      tittel={data.tittel}
      fornavn={data.fornavn}
      utloper={data.utloper}
      aktivert={data.aktivert}
      innlost={data.innlost}
      heading={`Hei${data.fornavn ? `, ${data.fornavn}` : ""}! ❤️`}
      subheading="Vi har en liten hilsen til deg."
      onActivate={async () => (await api.post(`/coupon/${token}/activate`)).data}
      onRedeem={async () => (await api.post(`/coupon/${token}/redeem`)).data}
    />
  );
}
